const listpage = require('./listpage').default;
const formpage = require('./formpage').default;

module.exports = {
    listpage,
    formpage,
};
